import type { FC, SVGProps } from 'react';

const ChfWeightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.89538 21.4727L11.0993 21.4993L18.3032 21.4727C18.9146 21.4727 19.93 20.9357 19.9513 19.9575C19.9725 18.9793 18.7816 12.0714 18.1702 8.71321C18.0928 8.28789 17.4789 7.33093 16.4954 7.33093H11.0993H5.70325C4.71971 7.33093 4.10586 8.28789 4.02843 8.71321C3.41704 12.0714 2.22609 18.9793 2.24735 19.9575C2.26862 20.9357 3.28399 21.4727 3.89538 21.4727Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.0531646"
    />
    <path
      d="M15.2757 4.62025C15.2757 6.89581 13.431 8.74051 11.1554 8.74051C8.87986 8.74051 7.03516 6.89581 7.03516 4.62025C7.03516 2.3447 8.87986 0.5 11.1554 0.5C13.431 0.5 15.2757 2.3447 15.2757 4.62025ZM9.03063 4.62025C9.03063 5.79374 9.98193 6.74503 11.1554 6.74503C12.3289 6.74503 13.2802 5.79374 13.2802 4.62025C13.2802 3.44677 12.3289 2.49548 11.1554 2.49548C9.98193 2.49548 9.03063 3.44677 9.03063 4.62025Z"
      fill="currentColor"
    />
    <path
      d="M11.9668 12.1C11.5879 11.4409 10.6385 11.4409 10.2595 12.1M11.9668 12.1L10.2595 12.1M11.9668 12.1L15.558 18.346C15.9342 19.0005 15.4663 19.8255 14.7044 19.8255H7.52198C6.76007 19.8255 6.29209 19.0005 6.66835 18.346L10.2595 12.1M11.9668 12.1L10.2595 12.1"
      stroke="var(--page-bg)"
      strokeWidth="1.12088"
    />
    <path
      d="M11.7274 12.2377C11.4546 11.7633 10.7717 11.7633 10.4989 12.2377L6.90776 18.4837C6.63636 18.9557 6.97442 19.5493 7.52198 19.5493H14.7044C15.2519 19.5493 15.59 18.9557 15.3186 18.4837L11.7274 12.2377Z"
      fill="var(--page-bg)"
      stroke="currentColor"
      strokeWidth="0.568562"
    />
    <path
      d="M10.2501 15.1301V18.0939H9.6336V15.1301H10.2501ZM10.8574 18.0939V15.1301H11.4739V16.2444H11.4927C11.5197 16.1846 11.5588 16.1238 11.6099 16.0621C11.662 15.9994 11.7295 15.9473 11.8125 15.9058C11.8964 15.8633 12.0006 15.8421 12.1251 15.8421C12.2872 15.8421 12.4367 15.8846 12.5737 15.9695C12.7107 16.0534 12.8202 16.1803 12.9022 16.3501C12.9842 16.5189 13.0252 16.7307 13.0252 16.9854C13.0252 17.2333 12.9852 17.4427 12.9051 17.6134C12.826 17.7832 12.7179 17.912 12.5809 17.9998C12.4449 18.0866 12.2925 18.1301 12.1236 18.1301C12.004 18.1301 11.9022 18.1103 11.8183 18.0707C11.7353 18.0312 11.6673 17.9815 11.6142 17.9217C11.5612 17.8609 11.5207 17.7996 11.4927 17.7379H11.4652V18.0939H10.8574ZM11.4608 16.9825C11.4608 17.1146 11.4792 17.2299 11.5158 17.3283C11.5525 17.4267 11.6056 17.5034 11.675 17.5584C11.7445 17.6125 11.8289 17.6395 11.9283 17.6395C12.0286 17.6395 12.1135 17.612 12.183 17.557C12.2524 17.501 12.305 17.4238 12.3407 17.3254C12.3774 17.2261 12.3957 17.1117 12.3957 16.9825C12.3957 16.8542 12.3778 16.7413 12.3421 16.6438C12.3065 16.5464 12.2539 16.4702 12.1844 16.4152C12.1149 16.3602 12.0296 16.3327 11.9283 16.3327C11.8279 16.3327 11.743 16.3592 11.6736 16.4123C11.6051 16.4654 11.5525 16.5406 11.5158 16.638C11.4792 16.7355 11.4608 16.8503 11.4608 16.9825Z"
      fill="currentColor"
    />
    <circle cx="11.2907" cy="6.04289" r="4.66667" fill="var(--page-bg)" />
    <path
      d="M12.4588 5.75101C12.4588 6.39534 11.9365 6.91768 11.2922 6.91768C10.6478 6.91768 10.1255 6.39534 10.1255 5.75101C10.1255 5.10668 10.6478 4.58435 11.2922 4.58435C11.9365 4.58435 12.4588 5.10668 12.4588 5.75101Z"
      fill="currentColor"
    />
    <path
      d="M14.2247 3.55558L10.7548 5.29052C10.584 5.37592 10.54 5.59973 10.6657 5.74345L11.2368 6.39614C11.3464 6.52134 11.5383 6.52969 11.6583 6.41448L14.3909 3.79122C14.5115 3.67546 14.3742 3.48083 14.2247 3.55558Z"
      fill="currentColor"
    />
    <path
      d="M12.4588 5.75101C12.4588 6.39534 11.9365 6.91768 11.2922 6.91768C10.6478 6.91768 10.1255 6.39534 10.1255 5.75101C10.1255 5.10668 10.6478 4.58435 11.2922 4.58435C11.9365 4.58435 12.4588 5.10668 12.4588 5.75101Z"
      stroke="currentColor"
    />
    <path
      d="M14.2247 3.55558L10.7548 5.29052C10.584 5.37592 10.54 5.59973 10.6657 5.74345L11.2368 6.39614C11.3464 6.52134 11.5383 6.52969 11.6583 6.41448L14.3909 3.79122C14.5115 3.67546 14.3742 3.48083 14.2247 3.55558Z"
      stroke="currentColor"
    />
    <path
      d="M16.3966 5.75C16.3966 8.56895 14.1114 10.8542 11.2925 10.8542C8.47353 10.8542 6.18831 8.56895 6.18831 5.75C6.18831 2.93105 8.47353 0.645833 11.2925 0.645833C14.1114 0.645833 16.3966 2.93105 16.3966 5.75ZM6.76224 5.75C6.76224 8.25199 8.7905 10.2802 11.2925 10.2802C13.7945 10.2802 15.8227 8.25199 15.8227 5.75C15.8227 3.24801 13.7945 1.21975 11.2925 1.21975C8.7905 1.21975 6.76224 3.24801 6.76224 5.75Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.291667"
    />
  </svg>
);

export default ChfWeightIcon;
